<template>
<div>
<section class="about1">
 <NavBar />      
 <div class="insideabout1">
  <div class="techabout">
<p class="smartabout">We change the way you<br>move money.</p>
<p class="mathsabout">
Swychr helps you spend, send, and save smarter across borders.<br> 
Welcome to your new favorite way to manage all things money. Let's<br>
simplify your financial world.
</p>
 
</div>
</div> 
  </section> 


  <section class="about2">
    <div class="insideabout2">
      <div class="mission-top">
        <div class="mission-label">
          <h2>Our Global Mission</h2>
        </div>
        <div class="mission-statement">
          <p class="main-statement">
            Our mission is for every person and business in Africa and beyond to access the global economy with the same ease as a local transaction.
          </p>
          <div class="statement-sub-grid">
            <p>We believe that financial borders are the last remaining hurdle to true global equality. By leveraging
               regulated microfinance structures and blockchain technology, we are bridging the gap between local fiat and global digital assets.</p>
            <p>SwyChr is not just an app; it is a fundamental reconfiguration of value exchange
             built on the pillars of transparency, institutional security, and radical accessibility.</p>
          </div>
        </div>
      </div>

      <div class="mission-quote">
        <h3>Why we come to work every day</h3>
        <blockquote>
          “We see the friction in the market not as a problem, but as an architectural challenge. We build because we know that when money moves freely, communities thrive.”
        </blockquote>
        </div>
   

     <div class="values-grid">
  <div v-for="(value, index) in values" :key="index" class="value-item">
    <div class="value-icon-wrapper">
      <img :src="value.icon" :alt="value.title" class="mission-icon" />
    </div>
    <h4>{{ value.title }}</h4>
    <p>{{ value.desc }}</p>
  </div>
</div>
    </div>
  </section>

<section class="about3">
    <div class="insideabout3">
      <div class="journey-header">
        <span class="journey-label">The Journey</span>
        <h2 class="journey-title">What we've done so far</h2>
      </div>

      <div class="journey-grid">
        <div v-for="(milestone, index) in milestones" :key="index" class="journey-card">
          <h3 class="milestone-title">{{ milestone.title }}</h3>
          <p class="milestone-desc">{{ milestone.desc }}</p>
        </div>
      </div>
    </div>
    <div class="glass-decoration">
      <img src="@/assets/images/plui.png" alt="">
    </div>
  </section>


<section class="about4">
    <div class="insideabout4">
      <div class="gov-text">
        <h2 class="gov-title">The Board & Governance</h2>
        <p class="gov-description">
          Integrity is our primary currency. SwyChr is overseen by a board of veterans from global telecommunications, finance, and technology. We adhere to the highest international standards of AML/KYC and regulatory transparency.
        </p>
        
       <div class="gov-links">
  <a v-for="(link, index) in governanceLinks" 
     :key="index" 
     :href="link.url" 
     class="gov-link-item"
  >
    <img :src="link.icon" :alt="link.name" class="link-icon" />
    <span class="link-text">{{ link.name }}</span>
  </a>
</div>
      </div>

      <div class="gov-image-wrapper">
        <img src="@/assets/images/trump.png" alt="Governance Building" class="gov-img" />
      </div>
    </div>
  </section>

<section class="about5">
    <div class="insideabout5">
      <div class="leadership-header">
        <h2 class="leadership-title">Meet Our Leadership</h2>
        <span class="leadership-subtitle">Founding Visionaries</span>
      </div>

      <div class="leadership-grid">
        <div v-for="(leader, index) in team" :key="index" class="leader-card">
          <div class="leader-image-box">
            <img :src="leader.image" :alt="leader.name" class="leader-img" />
          </div>
          
          <div class="leader-info">
            <h3 class="leader-name">{{ leader.name }}</h3>
            <p class="leader-role">{{ leader.role }}</p>
            <p class="leader-bio">{{ leader.bio }}</p>
            
            <a :href="leader.linkedin" target="_blank" class="linkedin-link">
              LinkedIn <span class="arrow">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="about6">
    <div class="glow-orb glow-1"></div>
    <div class="glow-orb glow-2"></div>

    <div class="insideabout6">
      <h2 class="founder-label">A Message from our Founder</h2>
      
      <div class="founder-card">
        <h3 class="card-headline">Building a Board for the Next Billion</h3>
        
        <div class="quote-body">
          <p class="quote-text">
            “The journey to connect Africa’s fragmented financial landscape requires more than just code; it requires institutional wisdom. Our board isn’t just a regulatory necessity; it’s our strategic compass.”
          </p>
          
          <p class="quote-text">
            “We have assembled a group of leaders who have scaled the continent’s largest telecommunications networks and navigated its most complex financial shifts. Together, we are building the bedrock for the next generation of global citizens.”
          </p>
        </div>

        <div class="founder-signature">
          <div class="avatar-box">
            <img src="@/assets/images/tebaba.jpeg" alt="Aaron Munga" class="avatar-img" />
          </div>
          <div class="signature-info">
            <h4 class="founder-name">Aaron Munga</h4>
            <p class="founder-title">CEO,The SwyCh Group.</p>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="about7">
     <BoardView /> 
  
    <div class="insideabout71">
      <h2 class="section-title">Our Dream Team</h2>
      <p class="team-description">
        Beyond the boardroom, SwyChr is powered by a dedicated team across our hubs in Delaware (USA), Buea (Cameroon), and Kigali (Rwanda). From our B2B Sales Leads to our Junior Web Developers, every member of the SwyChr team is committed to one goal: Financial freedom for all.
      </p>

<div class="location-grid">
  <div v-for="(loc, index) in locations" :key="index" class="location-item">
    <div class="icon-container">
       <img :src="loc.icon" alt="location" class="location-icon" />
    </div>
    
    <div class="location-text-block">
      <h4 class="city-name">{{ loc.city }}</h4> <p class="hub-type">{{ loc.type }}</p>    </div>
  </div>
</div>
    </div>
  </section>

  <FooterView />

</div>
 </template> 

  <script setup>
import FooterView from '@/components/FooterView.vue';  
import NavBar from '@/components/NavBar.vue';
import BoardView from '@/components/BoardView.vue';
import trustIcon from '@/assets/images/bum1.png'
import visionIcon from '@/assets/images/bum2.png'
import securityIcon from '@/assets/images/bum3.png'
import boardIcon from '@/assets/images/Container.png'
import policyIcon from '@/assets/images/Container (1).png'
import aaronImg from '@/assets/images/aaron.jpeg' 
import locIcon from '@/assets/images/bvlog.png'
const conradImg = '/conrad.PNG';

const values = [
  { 
    icon: trustIcon, 
    title: 'Institutional Trust', 
    desc: 'We operate with the rigor of traditional finance while embracing the agility of a fintech pioneer.' 
  },
  { 
    icon: visionIcon, 
    title: 'Pan-African Vision', 
    desc: 'Connecting the fragmented markets of Africa into a unified powerhouse of economic exchange.' 
  },
  { 
    icon: securityIcon, 
    title: 'User-First Security', 
    desc: 'Your assets are protected by world-class encryption and real-time transaction monitoring.' 
  }
];

const milestones = [
  {
    title: 'US +$250M Global Volume',
    desc: 'Over +$250M in transactions processed securely for our customers worldwide.'
  },
  {
    title: '50,000+ Strong',
    desc: 'Empowering a diverse community of over 50,000 customers globally.'
  },
  {
    title: 'Borderless Reach',
    desc: 'Scaling rapidly with an active operational footprint in 60+ countries.'
  },
  {
    title: 'Versatile Solutions',
    desc: 'Proven B2B and B2C products designed for both local markets and global scale.'
  }
];

const governanceLinks = [
  { 
    name: 'Meet the Board', 
    url: '/Board', 
    icon: boardIcon 
  },
  { 
    name: 'Policy Framework', 
    url: '#', 
    icon: policyIcon 
  }
];


const team = [
  {
    name: 'Aaron Munga',
    role: 'Founder & Chief Executive Officer',
    bio: 'Aaron brings over a decade of high-level experience across the corporate and startup landscapes to Swychr. A finance professional by training and a second-time founder, he previously served as Co-founder and CEO of the e-grocery startup Jump the Q. As the visionary behind Swychr, Aaron has successfully transitioned the company from a foundational concept into a global powerhouse, now serving over 50,000 customers with an operational footprint spanning more than 30 countries. He holds a Bachelor’s degree in Applied Accounting from Oxford Brookes University.',
    image: aaronImg,
    linkedin: 'https://www.linkedin.com/in/aaron-munga-1b793672/'
  },
  {
    name: 'Harshit Sinha',
    role: 'Co-Founder & Chief Technology Officer',
    bio: 'Harshit directs the technical evolution of Swychr, bringing over 15 years of experience in building transformative technology from the ground up. A third-time founder and a graduate of the prestigious Indian Institute of Technology (IIT), Harshit previously co-founded and served as CTO of the e-grocery platform Jump the Q. At Swychr, he has shepherded the product from its initial concept to a sophisticated multi-vertical ecosystem, successfully launching B2B, B2C, local, and global solutions that power our international reach.',
    image: conradImg,
    linkedin: 'https://www.linkedin.com/in/harshit-sinha-21075617/'
  }
];


const locations = [
  { city: 'Delaware, USA', type: 'Global Headquarters', icon: locIcon },
  {icon: locIcon ,type: 'Operations Hub',city: 'Buea, Cameroon'},
  { city: 'Kigali, Rwanda', type: 'Tech & Innovation', icon: locIcon },
  { city: 'Wyoming, USA', type: 'Tech & Innovation', icon: locIcon }
];
 </script>

 <style scoped>
.about1{
  text-align: center;
  margin: 0 auto;
  padding: 0.625rem 0;
  height: auto;
  position: relative; 
  width: 100%;
  height: 100vh;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-image: url('@/assets/images/jrist.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.seam{
margin-top: 20px;
margin-left: 67px;
}

.techabout{
  text-align: justify;
  line-height: 1;
  margin-left: 6.61vw; 
}

.insideabout1 {
  padding-top: 5rem; 
  display: block;
  align-items: center;
  justify-content: center;
  width: 90vw;
  margin-top: 0; 
}

.smartabout{
  margin-bottom: 0;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 2.9rem; 
  font-style: normal;
  font-weight: 600;
  line-height: 95%;
  padding-top: 0;
  margin-right: 3.125vw;
}

.mathsabout{
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.960rem;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  letter-spacing: 0.075rem; 
  margin-top: 0.5rem;
}



.about2{
  padding: 8rem 2rem;
  background-color: #F8F9FA;
  font-family: 'Montserrat', sans-serif;
  color: #282828;
}

.insideabout2{
  max-width: 75rem;
  margin: 0 auto;
}

.mission-top {
  display: flex;
  gap: 4rem;
  margin-bottom: 8rem;
}

.mission-label { flex: 1; }
.mission-label h2 { font-size: 2rem; font-weight: 700; color: #1a1a1a; }

.mission-statement { flex: 2; }
.main-statement {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 3rem;
  color: #1a1a1a;
   font-family: 'Montserrat', sans-serif;
  font-style: normal;
  text-align: justify;
}

.statement-sub-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  font-style: normal;
  font-size: 0.99rem;
  color: #000;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: 0.035rem; 
  text-align: justify;
}

.mission-quote {
  text-align: center;
  margin-bottom: 8rem;
}

.mission-quote h3 { font-size: 1.75rem; margin-bottom: 1.5rem; font-weight: 700; }
.mission-quote blockquote {
  font-size: 1.25rem;
  color: #000;
  font-style: normal;
  font-family: 'Montserrat', sans-serif;
  max-width: 45rem;
  margin: 0 auto;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4rem;
}

.value-item { 
   text-align: left;
   border: 1px solid #000; 
   border-radius: 1.25rem;
   height:12rem;
  padding-left:1rem;
  padding-top: 0.5rem;
  }

.value-icon { font-size: 1.5rem; margin-bottom: 1rem; }
.value-item h4 { font-size: 1.2rem; margin-bottom: 1rem; font-weight: 700; }
.value-item p {
    font-size: 0.9rem;
    color: #555;
    line-height: 1.6;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
  }

.value-icon-wrapper {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start; 
}

.mission-icon {
  width: 2rem;
  height: 2rem;
  object-fit: contain;
}


@media only screen and (max-width: 430px) {
  .value-icon-wrapper {
    justify-content: center; 
  }
  
  .mission-icon {
    width: 2rem; 
  }
}

@media only screen and (max-width: 1180px) {
  .mission-top { gap: 2rem; }
  .main-statement { font-size: 1.75rem; }
  .values-grid { gap: 2rem; }
}


@media only screen and (max-width: 430px) {
  .about2 { padding: 4rem 1.25rem; }

  .mission-top {
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 4rem;
  }

  .main-statement { font-size: 1.5rem; text-align: left; }

  .statement-sub-grid {
    grid-template-columns: 1fr; 
    gap: 1.5rem;
  }

  .mission-quote { margin-bottom: 5rem; }
  .mission-quote h3 { font-size: 1.4rem; }
  .mission-quote blockquote { font-size: 1.1rem; padding: 0 1rem; }

  .values-grid {
    grid-template-columns: 1fr; 
    gap: 3rem;
  }

  .value-item { text-align: center; } 
}


.about3 {
  background-color: #05070A;
  padding: 6rem 2rem;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  position: relative;
  overflow: hidden;
}

.insideabout3 {
  max-width: 80rem;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  margin-left: 3.5rem;
}

.journey-header {
  margin-bottom: 4rem;
  text-align: left;
}

.journey-label {
  color: #8B949E;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  display: block;
  margin-bottom: 0.5rem;
}

.journey-title {
  font-size: 2.5rem;
  font-weight: 600;
}

.journey-grid {
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
}

.journey-card {
  flex: 1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 2.5rem 1.5rem;
  min-height: 12rem;
  transition: all 0.3s ease;
}

.journey-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(140, 27, 193, 0.5); 
  transform: translateY(-5px);
}

.milestone-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
}

.milestone-desc {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #A0A0A0;
}

.glass-decoration img{
  position: absolute;
  top: 10%;
  right: -1%;
  width: 16rem;
  height: 16rem;
  z-index: 1;
  pointer-events: none;
}


@media only screen and (max-width: 1180px) {
  .journey-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media only screen and (max-width: 430px) {
  .about3 {
    padding: 4rem 1.25rem;
  }

  .journey-title {
    font-size: 1.8rem;
    line-height: 1.2;
  }

  .journey-grid {
    flex-direction: column;
    gap: 1rem;
     
  }

  .journey-card {
    min-height: auto;
    padding: 2rem 1.5rem;
   
  }
}


.about4 {
  padding: 6rem 2rem;
  background-color: #F8F9FA; 
  font-family: 'Montserrat', sans-serif;
  color: #282828;
}

.insideabout4 {
  max-width: 75rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 5rem;
}

.gov-text {
  flex: 1.2;
}

.gov-title {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1a1a1a;
  padding-right: 10rem;
}

.gov-description {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 2.5rem;
  text-align: justify;
}

.gov-links {
  display: flex;
  gap: 2rem;
}

.gov-link {
  font-size: 0.9rem;
  font-weight: 600;
  color: #8C1BC1; 
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}

.gov-image-wrapper {
  flex: 1;
}

.gov-img {
  width: 65%;
  height: auto;
  border-radius: 1rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.gov-links {
  display: flex;
  gap: 2.5rem;
  margin-top: 1rem;
}

.gov-link-item {
  display: flex;
  align-items: center;
  gap: 0.75rem; 
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.gov-link-item:hover {
  opacity: 0.7;
}

.link-icon {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
}

.link-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #000; 
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}


@media only screen and (max-width: 430px) {
  .gov-links {
    flex-direction: column; 
    align-items: center;
    gap: 1.5rem;
  }

  .gov-link-item {
    width: fit-content;
    justify-content: center;
  }

  .link-icon {
    width: 1.25rem; 
  }
}

@media only screen and (max-width: 1180px) {
  .insideabout4 {
    gap: 3rem;
  }

  .gov-title {
    font-size: 1.8rem;
  }

  .gov-description {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 430px) {
  .about4 {
    padding: 4rem 1.25rem;
  }

  .insideabout4 {
    flex-direction: column-reverse;
    gap: 2.5rem;
  }

  .gov-title {
    font-size: 1.6rem;
    text-align: center;
  }

  .gov-description {
    font-size: 0.95rem;
    text-align: center;
  }

  .gov-links {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
  }
}


.about5 {
  padding: 6rem 2rem;
  background-color: #F8F9FA;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
}

.insideabout5{
  max-width: 75rem;
  margin: 0 auto;
}

.leadership-header {
  margin-bottom: 4rem;
}

.leadership-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.leadership-subtitle {
  color: #666;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}

.leadership-grid {
  display: flex;
  justify-content: center;
  gap: 3rem;
}

.leader-card {
  flex: 1;
  max-width: 32rem;
  text-align: left;
  background: #ffffff;
  border-radius: 1.25rem;
  overflow: hidden;
  border: 1px solid #EAEAEA;
  transition: transform 0.3s ease;
}

.leader-card:hover {
  transform: translateY(-8px);
}

.leader-image-box {
  width: 100%;
  aspect-ratio: 1 ;
  background-color: #DDE2E8; 
  overflow: hidden;
}

.leader-img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.leader-info {
  padding: 2rem;
}

.leader-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.leader-role {
  color: #8C1BC1; 
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 1.25rem;
}

.leader-bio {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.linkedin-link {
  text-decoration: none;
  color: #1a1a1a;
  font-weight: 700;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.linkedin-link:hover .arrow {
  transform: translateX(4px);
}

.arrow {
  transition: transform 0.2s ease;
}

@media only screen and (max-width: 1180px) {
  .leadership-grid {
    gap: 1.5rem;
  }
  
  .leader-info {
    padding: 1.5rem;
  }
}

@media only screen and (max-width: 430px) {
  .about6 {
    padding: 4rem 1.25rem;
  }

  .leadership-grid {
    flex-direction: column;
    align-items: center;
    gap: 2.5rem;
  }

  .leader-card {
    width: 100%;
    max-width: 100%;
  }

  .leader-info {
    text-align: center;
  }

  .linkedin-link {
    justify-content: center;
  }
}

.about6 {
  background-color: #05070A;
  padding: 8rem 2rem;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  position: relative;
  overflow: hidden;
  text-align: center;
  background-image: url('@/assets/images/dupliy.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.insideabout6{
  max-width: 60rem;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}

.founder-label {
  font-size: 1.25rem;
  font-weight: 500;
  color: #E0E0E0;
  margin-bottom: 3.5rem;
  opacity: 0.9;
}

.founder-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 2rem;
  padding: 4rem;
  text-align: left;
  backdrop-filter: blur(10px); 
}

.card-headline {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 2.5rem;
  letter-spacing: -0.02rem;
}

.quote-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 3.5rem;
}

.quote-text {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #CCCCCC;
  font-style: italic;
}

.founder-signature {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.avatar-box {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background-color: #222; 
  border: 2px solid rgba(140, 27, 193, 0.5);
  overflow: hidden;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.founder-name {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.15rem;
}

.founder-title {
  font-size: 0.85rem;
  color: #8B949E;
}

.glow-orb {
  position: absolute;
  width: 30rem;
  height: 30rem;
  border-radius: 50%;
  filter: blur(100px);
  z-index: 1;
}

.glow-1 {
  background: rgba(93, 56, 160, 0.15);
  top: -10%;
  left: -10%;
}

.glow-2 {
  background: rgba(140, 27, 193, 0.1);
  bottom: -10%;
  right: -10%;
}

@media only screen and (max-width: 1180px) {
  .founder-card {
    padding: 3rem;
    width: 95%;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 430px) {
  .about6 {
    padding: 5rem 1rem;
  }

  .founder-label {
    font-size: 1.1rem;
  }

  .founder-card {
    padding: 2.5rem 1.5rem;
    border-radius: 1.5rem;
  }

  .card-headline {
    font-size: 1.4rem;
    line-height: 1.3;
  }

  .quote-text {
    font-size: 1rem;
    line-height: 1.6;
  }

  .avatar-box {
    width: 3rem;
    height: 3rem;
  }
}

.about7 {
  padding: 5rem 2rem;
  font-family: 'Montserrat', sans-serif;
  background-color: #FDFDFD;
  color: #333;
}

.header-group { text-align: center; margin-bottom: 4rem; }
.label-accent { color: #8C1BC1; font-weight: 600; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 1px; }
.section-title { font-size: 2.25rem; font-weight: 700; margin-top: 0.5rem; }


.board-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 65rem;
  margin: 0 auto 8rem;
}

.board-card {
  background: white;
  border: 1px solid #EEE;
  border-radius: 1rem;
  padding: 2.5rem 1.5rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
}

.member-photo-wrapper {
  width: 7rem;
  height: 7rem;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  overflow: hidden;
  background: #F1F1F1;
}

.member-photo { width: 100%; height: 100%; object-fit: cover; }

.member-name { font-size: 1.25rem; font-weight: 700; margin-bottom: 0.25rem; }
.member-role { color: #5D38A0; font-weight: 600; font-size: 0.85rem; margin-bottom: 1.25rem; }
.member-bio { font-size: 0.85rem; color: #666; line-height: 1.6; margin-bottom: 1.5rem; min-height: 5rem; }

.linkedin-profile {
  color: #0077B5;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
}

.insideabout71 { text-align: center; max-width: 60rem; margin: 0 auto; }
.team-description { color: #777; line-height: 1.8; margin: 1.5rem 0 4rem; font-size: 1rem; }


.location-grid {
  display: flex;
  justify-content: center;
  gap: 3rem; 
  margin-top: 4rem;
}

.location-item {
  display: flex;
  align-items: center; 
  gap: 1rem; 
  text-align: left;
}

.icon-container {
  flex-shrink: 0; 
}

.location-icon {
  width: 1.5rem; 
  height: auto;
}

.location-text-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.city-name {
  font-weight: 700;
  font-size: 1rem;
  margin: 0; 
  color: #282828;
}

.hub-type {
  font-size: 0.85rem;
  color: #888;
  margin: 2px 0 0 0;
}


@media only screen and (max-width: 430px) {
  .location-grid {
    flex-direction: column;
    align-items: flex-start; 
    padding-left: 15%; 
    gap: 2rem;
  }
}


.location-item { display: flex; align-items: center; gap: 0.75rem; text-align: left; }
.location-icon { width: 1.5rem; height: 1.5rem; }
.city-name { font-weight: 700; font-size: 0.95rem; }
.hub-type { font-size: 0.8rem; color: #888; }


@media only screen and (max-width: 1180px) {
  .board-grid { grid-template-columns: repeat(2, 1fr); }
  .location-grid { gap: 2rem; }
}


@media only screen and (max-width: 430px) {
  .about7 { padding: 3rem 1.25rem; }
  .section-title { font-size: 1.75rem; }
  
  .board-grid { grid-template-columns: 1fr; gap: 1.5rem; }
  
  .location-grid { flex-direction: column; gap: 2rem; align-items: flex-start; padding-left: 10%; }
  
  .member-bio { min-height: auto; }
}

.footerabout {
           font-family: 'Montserrat', sans-serif;
            margin: 0;
            background: linear-gradient(#29013E,#28013C,#170124);
            color: #fff;
            width: 100%;  
           margin: 0 auto;
        }
           
        
.mothers11about{
          display: flex;
          margin-bottom: 20px;
          text-align: justify;
           margin-left: 55px;
        }
        
.mother11about{
            margin: 1.1rem;
            text-align: center;
            text-align: justify; 
            margin-left: 2rem;
        }  

        .mother-number11about{
          font-size:20px;
          font-weight: bold;
          display: inline-flex;
          align-items: center;
          justify-content: center;
       
        }

        .mother-pip11about{
          flex: 1;
          text-align: justify;
          align-items: center;
          padding: 10px;
        } 

        .icon-fb{
          width: 24px;
         height: 24px;
         aspect-ratio: 1/1;
        }
        
        .arrow-1{
          color: white;
          width: 24px;
          height: 24px;
          margin-left: 5px;
        }
    
.footerabout a{
text-decoration: none;
color:  #ffffff;
font-family: 'Montserrat', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 535;
line-height: 120%;
text-align:justify;
}

.footerabout i{
    margin-right: 8px;
        }
        
 .span1about{
text-align: justify;
color: var(--WhiTE-mAIN, #FFF);
font-family: 'Montserrat', sans-serif;
font-size: 17px;
font-style: normal;
font-weight: 550;
line-height: 120%;
margin-right: 2.8rem;
}

.span2about{
  font-size: 25px;
  color: #ffffff;
}

 .mother-pip115about{ 
  text-align: justify;
  align-items: center;
  color: #ffffff;
        } 
  
  .schoolabout{
  border-top: 1px solid #fff;
  width: 92%;
  margin-left: 60px;
 }   
 
  .showabout{
color: #ffffff;
font-family: 'Montserrat', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 535;
line-height: 120%;
 }
 

.sergioabout {
  display: flex; 
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 30px auto; 
  padding: 0;
}


.zoukieabout{
  margin-right: 0; 
  text-align: left;
}


.chanaabout {
  margin-right: 0;
  display: flex;
  gap: 20px; 
  list-style: none;
  padding: 0;
}


.chana1about{
  white-space: nowrap;
}


.rufusabout{
  margin: 40px auto; 
  width: 90%;
  text-align: justify;
  font-size: 14px;
  line-height: 1.6;
}

.seam{
margin-top: 20px;
margin-left: 67px;
}

@media only screen and (max-width: 820px) {
  .sergioabout{
    flex-direction: column; 
    align-items: center;
    text-align: center;
    gap: 20px;
  }
  
  .zoukieabout {
    text-align: center;
  }
  
  .chanaabout{
    justify-content: center;
  }
}

 @media only screen and (max-width: 1180px) {
  .about1 {
    height: auto;
    min-height: 100vh;
  }

  .insideabout1 {
    padding-top: 8rem;
    width: 92vw;
  }

  .smartabout{
    font-size: 3rem;
  }

  .mathsabout{
    max-width: 85%;
  }

}

@media only screen and (max-width: 430px) {
  .about1 {
    height: auto;
    min-height: 100vh;
    overflow-y: visible;
  }

  .background-image {
    width: 100%;
    height: 100%;
  }


  .food-pill-container {
    width: 96vw;
    height: 3rem;
    padding: 0 0.25rem;
  }

  .insideabout1 {
    padding-top: 4rem;
    width: 100%;
  }

  .techabout {
    margin-left: 0;
    text-align: center;
    padding: 0 1.25rem;
  }

  .smartabout{
    font-size: 2.1rem;
    line-height: 1.1;
    margin-bottom: 1rem;
    margin-right: 0;
  }

  .mathsabout{
    font-size: 0.95rem;
    line-height: 1.5;
    letter-spacing: 0.02rem;
    padding: 0 0.5rem;
    br { display: none; } 
  }
}

@media only screen and (max-width: 1180px) {
    .mothers11about {
        flex-wrap: wrap;
        margin-left: 20px;
        justify-content: space-around;
        gap: 20px;
    }

    .mother11about {
        flex: 1 1 30%; 
        margin-left: 0;
        text-align: left;
    }

    .mother-pip11about, .mother-pip115about{
        text-align: left;
    }

    .schoolabout {
        width: 95%;
        margin: 20px auto;
    }

    .sergioabout {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-left: 20px;
        gap: 15px;
    }

    .zoukieabout{
        margin-right: 0;
    }

    .chanaabout {
        margin-right: 0;
        padding: 0;
    }

    .rufusabout{
        margin-left: 20px;
        width: 90%;
        font-size: 14px;
    }
}

@media only screen and (max-width: 430px) {
    .footerabout {
        padding-bottom: 40px;
    }

    .mothers11about {
        flex-direction: column; 
        margin-left: 20px;
        gap: 35px;
    }

    .mother11about {
        width: 100%;
        margin: 0;
    }

    .mother-number11about {
        justify-content: flex-start;
        margin-bottom: 10px;
    }

    .span1about, .span2about {
        margin: 0;
    }

    .mother-pip11about br, .mother-pip115about br {
        display: none; 
    }

    .sgroupabout {
        margin-top: 15px;
        display: flex;
        gap: 20px;
    }

    .schoolabout {
        width: 90%;
        margin: 30px auto;
    }

    .sergioabout {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
    }

    .chanaabout{
        flex-direction: column;
        gap: 10px;
    }

    .chana1about {
        font-size: 14px;
    }

    .rufusabout{
        margin: 25px 20px 0 20px;
        font-size: 12px;
        line-height: 1.5;
        width: auto;
    }
}


@media only screen and (max-width: 430px) {
  .mothers11about {
    margin-left: 0 !important;
    padding: 0 1rem;
    display: flex !important;
    flex-direction: column !important; 
    align-items: center !important;
    width: 100%;
    gap: 3rem;
  }


  .mother11about {
    margin: 0 auto !important;
    padding: 0;
    width: 90%; 
    text-align: center !important; 
  }


  .mother-number11about {
    display: flex !important;
    justify-content: center !important;
    width: 100%;
    margin-bottom: 0.625rem;
  }

  .span1about, .span2about {
    margin: 0 !important;
    font-size: 1.5rem !important;
    line-height: 1.1;
  }


  .sgroupabout {
    margin: 1rem auto 0 auto !important;
    display: flex;
    justify-content: center;
    gap: 1.5rem; 
  }


  .showabout{
    margin: 1.25rem 0;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.5;
    width: 100%;
    display: block;
    margin-left: 0 !important;
  }

  
  .mother-pip11about {
    margin: 0 auto !important;
    padding: 0;
    display: flex !important;
    flex-direction: column !important; 
    align-items: center !important;
    gap: 0.75rem; 
    width: 100%;
  }


  .mother-pip11about a{
    display: block !important;
    width: 100%;
    text-align: center !important;
    padding: 0.5rem 0;
    font-size: 1rem;
  }

  .mother-pip11about br {
    display: none !important;
  }
}
</style>